const DEFAULT_COMMENT = 'Хочу квартиру по стартовой цене';

export function buildLayoutComment(selectedLayout) {
  if (!selectedLayout) {
    return DEFAULT_COMMENT;
  }

  const { rooms, title, area } = selectedLayout;
  return `${rooms}, ${title}, ${area}`;
}
